module.exports = __webpack_public_path__ + "img/mian-video-cover.ee2c167.jpg";